import { Controller } from "@hotwired/stimulus"

// Lightweight controller for contenteditable text blocks.
// Formatting toolbar is rendered inline by document-builder controller.
// This handles: backspace-to-exit-list and active state updates.
export default class extends Controller {
  connect() {
    this.element.addEventListener("keydown", this.handleKeydown)
    this.element.addEventListener("keyup", this.updateParentToolbar)
    this.element.addEventListener("mouseup", this.updateParentToolbar)
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.handleKeydown)
    this.element.removeEventListener("keyup", this.updateParentToolbar)
    this.element.removeEventListener("mouseup", this.updateParentToolbar)
  }

  handleKeydown = (e) => {
    if (e.key === "Tab") {
      if (this.isInList()) {
        e.preventDefault()
        if (e.shiftKey) {
          document.execCommand("outdent", false, null)
        } else {
          document.execCommand("indent", false, null)
        }
        this.element.dispatchEvent(new Event("input", { bubbles: true }))
        this.updateParentToolbar()
      }
      return
    }

    if (e.key !== "Backspace" && e.key !== "Delete") return

    const sel = window.getSelection()
    if (!sel.rangeCount) return

    const li = sel.anchorNode?.closest?.("li") || sel.anchorNode?.parentElement?.closest?.("li")
    if (!li) return

    const text = li.textContent.trim()
    if (text.length > 0) return
    if (sel.anchorOffset > 0) return

    e.preventDefault()

    if (document.queryCommandState("insertUnorderedList")) {
      document.execCommand("insertUnorderedList", false, null)
    } else if (document.queryCommandState("insertOrderedList")) {
      document.execCommand("insertOrderedList", false, null)
    }

    this.updateParentToolbar()
  }

  isInList() {
    const sel = window.getSelection()
    if (!sel.rangeCount) return false
    let node = sel.anchorNode
    while (node && node !== this.element) {
      if (node.nodeName === "LI" || node.nodeName === "UL" || node.nodeName === "OL") return true
      node = node.parentNode
    }
    return false
  }

  updateParentToolbar = () => {
    // Dispatch to the document-builder controller to update format button states
    const blockEl = this.element.closest("[data-block-id]")
    if (!blockEl) return

    const toolbar = blockEl.querySelector("[data-text-toolbar]")
    if (!toolbar) return

    const commands = ["bold", "italic", "underline", "insertUnorderedList", "insertOrderedList"]
    toolbar.querySelectorAll("[data-command]").forEach(btn => {
      const command = btn.dataset.command
      if (!commands.includes(command)) return
      const isActive = document.queryCommandState(command)
      if (isActive) {
        btn.classList.add("bg-primary-100", "text-primary-700")
        btn.classList.remove("text-neutral-500")
      } else {
        btn.classList.remove("bg-primary-100", "text-primary-700")
        btn.classList.add("text-neutral-500")
      }
    })
  }
}
